import { useEffect, useRef, useState } from "react";
import "../components/Hello.css";

const Hello = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target); // animacja tylko raz
          }
        });
      },
      { threshold: 0.2 } // 20% widoczności wyzwala animację
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`hello-container ${isVisible ? "visible" : ""}`}
    >
      <div className="hello-content">
        <h2>
          WIERZĘ, ŻE DOBRA ARCHITEKTURA RODZI SIĘ Z EMPATII I UWAŻNOŚCI
        </h2>
        <p>
          Gwarantuję terminowość, transparentną komunikację i pełne
          zaangażowanie na każdym etapie projektu.
        </p>
      </div>
      <div className="hello-line"></div>
    </div>
  );
};

export default Hello;
